import React, { useEffect } from 'react';
import { ExternalLink } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';

interface RedirectPageProps {
  title: string;
  description: string;
  url: string;
  icon: React.ReactNode;
}

const RedirectPage: React.FC<RedirectPageProps> = ({ title, description, url, icon }) => {
  useEffect(() => {
    // Open the URL in a new tab
    window.open(url, '_blank');
  }, [url]);

  return (
    <div className="min-h-screen flex flex-col bg-[#111111]">
      <Navbar />
      
      <main className="flex-1 mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-8">
            {icon}
            <h1 className="text-4xl font-bold text-white">{title}</h1>
          </div>

          <div className="bg-[#222222] rounded-lg p-12 text-center max-w-2xl mx-auto">
            <ExternalLink className="w-16 h-16 text-cardinal mx-auto mb-6" />
            <h2 className="text-2xl font-bold text-white mb-4">Opening in a New Tab</h2>
            <p className="text-gray-400 mb-8 text-lg leading-relaxed">
              {description}
            </p>
            <div className="space-y-4">
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-8 py-4 bg-cardinal hover:bg-cardinal-hover text-white rounded-lg text-lg font-semibold transition-all hover:scale-105 hover:shadow-glow"
              >
                Click here if the page doesn't open automatically
                <ExternalLink className="w-5 h-5 ml-2" />
              </a>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RedirectPage;